import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { API } from '../../App'

const AmcInvest = () => {
    document.title = "How Can Invest";
    document.querySelector('meta[name="description"]').setAttribute('content', "How Can Invest");
    const [data,setData] = useState("")
    const {_id} = useParams()
    const getData = async() => {
        const response = await API.post("/amc/detail/howcaninvest",{amc_id:_id})
        setData(response.data.data.howCanInvest)
    }
    useEffect(()=>{
        getData()
    },[])
    return (
        <div className='balance-webview'>
            <Container>
                <Row>
                    <Col xs={12}>
                        <div className="content" dangerouslySetInnerHTML={{__html: data}}></div>    
                    </Col>
                </Row>
            </Container >
        </div >
    )
}

export default AmcInvest